export default {
  rawColors: {
    neutralWhite: '#FFFFFF',
    neutralBlack: '#191919',
    accent200: '#FF0000',
    accent300: '#FF2515',
    accent500: '#E80808',
    accent700: '#CC010F',
    lightGreyBorder: '#EAEAEA',
    lightGrey300: '#F2F2F2',
    lightGrey400: '#E9E6DF',
    lightGrey500: '#E1E1E1',
    lightGrey700: '#CCCCCC',
    lightGreyBg: '#F2F2EF',
    lightGreyBg2: '#F6F5F3',
    lightGreyBgProduct: '#F9F9F9',
    lightGreyInterior: '#E4E7EA',
    beige300: '#F6F5F3',
    beige500: '#E9E6E4',
    shadowGrey: '#E5E0DB',
    uspGrey: '#506C5E1A',
    darkGrey300: '#969696',
    darkGrey500: '#808184',
    darkGrey600: '#656566',
    darkGrey700: '#373737',
    dirtyPink200: '#F3E6E6',
    dirtyPink300: '#F9E4E1',
    dirtyPink500: '#E5C8C4',
    dirtyPink700: '#DBAFAC',
    saffron300: '#FFDA83',
    saffron500: '#FDCC55',
    saffron700: '#F9BE30',
    green100: '#E6F3E6',
    green300: '#4CAF50',
    green400: '#247C43',
    green500: '#388E3B',
    green700: '#1B5E1F',
    green800: '#E0F5E7',
    webGreen500: '#349f5a',
    blue300: '#37A5FF',
    blue400: '#2194F3',
    blue500: '#0D87F2',
    blue600: '#1A75D2',
    blue700: '#1163CC',
    blue800: '#1045A1',
    dirtyBlue300: '#E0EFF5',
    dirtyBlue500: '#BFD5DB',
    neon: '#E1F035',
    omnibus: '#767676',
    dashColor: '#656565',
  },
  fonts: {
    uniform: 'Uniform EC Condensed',
    uniformMedium: 'Uniform EC Condensed Medium',
    uniformExtra: 'Uniform EC Extra Condensed',
    noe: 'Noe Display',
  },

  mbSection: '12px',

  fontWeights: {
    thin: 100,
    ultraLight: 200,
    light: 300,
    normal: 400,
    medium: 500,
    semiBold: 600,
    bold: 700,
    ultraBold: 800,
    heavy: 900,
  },
  fontSizes: {
    extraText: 26,
    bigText: 18,
    text: 16,
    smallText: 14,
    caption: 12,
    omnibus: 10,
    displayOne: 148,
    displayOneTablet: 80,
    displayFour: 104,
    displayFive: 96,
    bigHeading: 72,
    mediumHeading: 64,
    smallHeading: 60,
    smallerHeading: 52,
    smallestHeading: 46,
    displayMobile: 48,
    h1: 40,
    h2: 32,
    h3: 24,
    h4: 20,
    h5: 16,
    h6: 13,
  },
  letterSpacings: {
    normal: 'normal',
    caps: '0.05em',
    bigCaps: '0.1em',
    mediumCaps: '0.03em',
    smallCaps: '0.01em',
  },
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  styles: {
    root: {
      fontFamily: 'uniform',
      fontWeight: 'normal',
    },
    ul: {
      listStyle: 'none',
    },
  },
  breakpoints: ['480px', '768px', '1025px', '1280px', '1441px', '1600px', '1920px'],
  background: {
    mainSection: '#E1E1E1',
    section: '#F2F2EF',
    footer: '#E1E1E1',
    megaNav: '#F2F2F2',
    megaNavHover: '#FFFFFF',
    sideBar: '#FFFFFF',
    navGradient: 'linear-gradient(180deg, rgba(25, 25, 25, 0.2) 0%, rgba(25, 25, 25, 0) 100%)',
  },
  transitions: {
    time: {
      fast: '.24s',
      normal: '.3s',
      long: '.6s',
    },
    animation: {
      atomCurve: 'cubic-bezier(0, 0, 0.6, 1)',
    },
    linearNormal: '.2s linear',
    easeOutNormal: '.3s ease-out',
    atomTransition: '0.24s cubic-bezier(0, 0, 0.6, 1)',
  },
  layout: {
    container: {
      maxWidth: '1920px',
    },
    fluid: {
      maxWidth: '100%',
    },
    video: {
      maxWidth: ['100%', '100%', '100%', '79.6875vw'],
    },
  },
  grids: {
    staticPages: {
      p: ['0 16px', '0 16px', '0 24px', '0'],
      mx: 'auto',
      width: ['100%', '100%', '100%', '66.66%', '66.66%', '66.66%', '50%'],
    },
    container: {
      padding: {
        desktop: '0 40px',
        tabletNoMargin: 0,
        tabletSmallMargin: '0 24px',
        tabletBigMargin: '0 64px',
        mobileNoMargin: 0,
        mobileSmallMargin: '0 12px',
        mobileBigMargin: '0 40px',
      },
    },
    mainGrid: {
      display: 'grid',
      gridTemplateColumns: ['repeat(5 , 1fr)', 'repeat(5, 1fr)', 'repeat(6, 1fr)', 'repeat(6, 1fr)', 'repeat(12, 1fr)'],
      gridGap: ['2px', '2px', '4px', '4px', '24px', '24px'],
    },
  },
  zIndex: {
    search: 1000,
    megaMenu: 900,
    alerts: 800,
    aside: 700,
    modalUp: 600,
    modalDown: 500,
    barUp: 400,
    breadcrumbs: 320,
    barDown: 300,
    barMenu: 200,
    contextMenu: 100,
    filters: 75,
    documentHigh: 25,
    documentUp: 1,
    under: -1,
  },
};
